<script setup>
import {Modal} from 'ant-design-vue';
import {defineProps, defineEmits, watch, ref} from 'vue';
import convertNumberToCurrency from "@/utils/ConvertNumberToCurrency";
import {isArray} from "@apollo/client/utilities";
import {formatNewDate} from "@/utils/datetime";
import {shortenPhone} from "@/utils/validate";

// Nhận props
const props = defineProps({
  visible: Boolean,
  initialData: {
    type: Object,
    default: null
  }
});

const matchData = ref(props.initialData);
const classTourStatus = ref("");
const tourStatus = ref("");
const tournament = ref([]);
const set1 = ref([]);
const set2 = ref([]);
const set3 = ref([]);

// Emit sự kiện
const emit = defineEmits(['update:visible', 'success', 'cancel']);

const handleCancel = () => {
  emit('update:visible', false);
  emit('cancel');
};

const urlServe = process.env.VUE_APP_SERVER_URL

const statusMap = {
  upcoming: {text: "Sắp diễn ra", class: "badge bg-info"},
  pending: {text: "Đang diễn ra", class: "badge bg-warning"},
  ongoing: {text: "Đang diễn ra", class: "badge bg-primary"},
  finished: {text: "Đã kết thúc", class: "badge bg-success"},
  canceled: {text: "Đã huỷ", class: "badge bg-danger"},
};

const statusMatchMap = {
  NOT_SCHEDULED: {class: "badge bg-secondary", text: "Chưa lên lịch"},
  SCHEDULED: {class: "badge bg-info", text: "Đã lên lịch"},
  ONGOING: {class: "badge bg-primary", text: "Đang diễn ra"},
  PAUSED: {class: "badge bg-warning", text: "Tạm hoãn"},
  COMPLETED: {class: "badge bg-success", text: "Đã kết thúc"},
  CANCELED: {class: "badge bg-danger", text: "Đã huỷ"},
};

const convertDate = (isoString) => {
  const date = new Date(isoString);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

watch(
    () => props.initialData,
    (initData) => {
      if (initData) {
        matchData.value = initData;
        tournament.value = initData.tournament;
        tourStatus.value = statusMap[initData.tournament?.tour_status]?.text || "Không xác định";
        classTourStatus.value = statusMap[initData.tournament?.tour_status]?.class || "";

        const score_detail = initData.score_detail;
        if (score_detail) {
          const scrore_arr = JSON.parse(score_detail);

          set1.value = isArray(scrore_arr[0]) ? scrore_arr[0] : JSON.parse(scrore_arr[0]);
          set2.value = isArray(scrore_arr[1]) ? scrore_arr[1] : JSON.parse(scrore_arr[1]);
          set3.value = isArray(scrore_arr[2]) ? scrore_arr[2] : JSON.parse(scrore_arr[2]);
        } else {
          set1.value = set2.value = set2.value = [0, 0]
        }
      } else {
        console.log("no field")
      }
    },
);

</script>

<template>
  <Modal
      :open="props.visible"
      title="Xem thông tin chi tiết trận đấu"
      width="600px"
      okText="Đóng"
      cancelText="Hủy bỏ"
      @cancel="handleCancel"
      @ok="handleCancel"
  >
    <div class="row">
      <div class="col-lg-12">
        <div class="master-academy dull-whitesmoke-bg card master-academyview">
          <div class="row d-flex align-items-center justify-content-start">
            <div class="col-12">
              <div class="d-sm-flex justify-content-start align-items-center">
                <a href="javascript:void(0);">
                  <img :alt="tournament?.name" :src="urlServe + tournament?.photo?.url"
                       class="corner-radius-10 w-100" style="max-width: 200px"/>
                </a>
                <div class="info">
                  <h3 class="mb-2 d-flex gap-2">{{ tournament?.name }} <span :class="classTourStatus"
                                                                             class="h4">{{
                      tourStatus
                    }}</span></h3>
                  <div class="profile-set-content w-100 p-0">
                    <ul class="bg-transparent p-0">
                      <li>
                        <img alt="Icon" src="@/assets/img/icons/location.svg"/>
                        <h5>{{ tournament?.contact_address }}</h5>
                      </li>
                      <li>
                        <img alt="Icon" src="@/assets/img/icons/call.svg"/>
                        <h5>{{ tournament?.contact_phone }}</h5>
                      </li>
                    </ul>
                  </div>
                  <div class="coach-profile-set">
                    <ul class="bg-transparent p-0">
                      <li>
                        <div class="coach-profile-set-img">
                          <img alt="Icon" src="@/assets/img/icons/indoor.svg"/>
                        </div>
                        <div class="coach-profile-set-contemt">
                          <h5>Tổng giải thưởng</h5>
                          <span>{{ convertNumberToCurrency.formatMoney(tournament?.award_total ?? 0) }}</span>
                        </div>
                      </li>
                      <li>
                        <div class="coach-profile-set-img">
                          <img alt="Icon" src="@/assets/img/profiles/avatar-01.jpg"/>
                        </div>
                        <div class="coach-profile-set-contemt">
                          <h5>Tổng số VĐV</h5>
                          <span>{{ tournament?.num_player }}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="profile-tab">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button id="tour_match_info-tab1" aria-selected="true" class="nav-link active"
                      data-bs-target="#tour_match_info"
                      data-bs-toggle="tab" role="tab" type="button">
                Thông tin giải đấu
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button id="match_info-tab1" aria-selected="false" class="nav-link" data-bs-target="#match_info"
                      data-bs-toggle="tab" role="tab" type="button">
                Thông tin trận đấu
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button id="match_history-tab1" aria-selected="false" class="nav-link" data-bs-target="#match_history"
                      data-bs-toggle="tab" role="tab" type="button">
                Lịch sử trận đấu
              </button>
            </li>
          </ul>
          <div class="tab-content">
            <div id="tour_match_info" class="tab-pane fade show active" role="tabpanel">
              <!-- Accordian Contents -->
              <div class="accordion">
                <div id="infoTourMatch" class="accordion-item mb-4">
                  <h4 id="panelsStayOpen-infoTourMatch" class="accordion-header">
                    <button aria-controls="panelsStayOpen-collapseInfoTourMatch" aria-expanded="false"
                            class="accordion-button"
                            data-bs-target="#panelsStayOpen-collapseInfoTourMatch" data-bs-toggle="collapse"
                            type="button">
                      <span class="icon-bg"><img alt="Icon" src="@/assets/img/icons/lesson-with-me.svg"/></span>
                      Thông tin chung
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseInfoTourMatch" aria-labelledby="panelsStayOpen-infoTourMatch"
                       class="accordion-collapse collapse show">
                    <div class="accordion-body includes-set">
                      <ul class="amenities-set d-flex flex-column justify-content-start align-items-start">
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Ngày bắt đầu: {{ formatNewDate(tournament?.date_start) }}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Ngày kết thúc: {{ formatNewDate(tournament?.date_end) }}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Ngày bắt đầu đăng ký: {{ formatNewDate(tournament?.reg_start_date) }}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Ngày kết thúc đăng ký: {{ formatNewDate(tournament?.reg_end_date) }}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Tổng giải thưởng: {{ convertNumberToCurrency.formatMoney(tournament?.award_total ?? 0) }}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Số lượng người chơi: {{ tournament?.num_player }}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div id="descriptionTourMatch" class="accordion-item mb-4">
                  <h4 id="panelsStayOpen-descriptionTourMatch" class="accordion-header">
                    <button aria-controls="panelsStayOpen-collapseDescriptionTourMatch" aria-expanded="false"
                            class="accordion-button"
                            data-bs-target="#panelsStayOpen-collapseDescriptionTourMatch" data-bs-toggle="collapse"
                            type="button">
                      <span class="icon-bg"><img alt="Icon" src="@/assets/img/icons/Black.svg"/></span>Mô tả
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseDescriptionTourMatch"
                       aria-labelledby="panelsStayOpen-descriptionTourMatch"
                       class="accordion-collapse collapse show">
                    <div class="accordion-body includes-set">
                      <p>{{ tournament?.description ?? '---' }}</p>
                    </div>
                  </div>
                </div>

                <div id="rules" class="accordion-item mb-4">
                  <h4 id="panelsStayOpen-rulesTourMatch" class="accordion-header">
                    <button aria-controls="panelsStayOpen-collapseRulesTourMatch" aria-expanded="false"
                            class="accordion-button"
                            data-bs-target="#panelsStayOpen-collapseRulesTourMatch" data-bs-toggle="collapse"
                            type="button">
                      <span class="icon-bg"><img alt="Icon" src="@/assets/img/icons/lesson-with-me.svg"/></span>
                      Quy tắc
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseRulesTourMatch" aria-labelledby="panelsStayOpen-rulesTourMatch"
                       class="accordion-collapse collapse show">
                    <div class="accordion-body includes-set">
                      <p>{{ tournament?.rule ?? '---' }}</p>
                    </div>
                  </div>
                </div>

                <div id="courts" class="accordion-item mb-4">
                  <h4 id="panelsStayOpen-courtsTourMatch" class="accordion-header">
                    <button aria-controls="panelsStayOpen-collapseCourtsTourMatch" aria-expanded="false"
                            class="accordion-button"
                            data-bs-target="#panelsStayOpen-collapseCourtsTourMatch" data-bs-toggle="collapse"
                            type="button">
                      <span class="icon-bg"><img alt="Icon" src="@/assets/img/icons/includes1.svg"/></span>
                      Sân thi đấu
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseCourtsTourMatch" aria-labelledby="panelsStayOpen-courtsTourMatch"
                       class="accordion-collapse collapse show">
                    <div class="accordion-body includes-set">
                      <ul v-for="(item, index) in tournament?.arenas" :key="item?.documentId ?? index">
                        <li>
                          <i class="feather-check-square"></i>{{ item.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Accordian Contents -->
            </div>
            <div id="match_info" class="tab-pane fade" role="tabpanel">
              <div class="profile-card mb-0 d-flex justify-content-between">
                <div class="w-50">
                  <div class="profile-card-title">
                    <h4>Đội 1</h4>
                  </div>
                  <div class="profile-contact-details mb-0 w-100">
                    <ul v-if="matchData?.tour_player_team_1?.player_1" class="w-100">
                      <li class="w-100">
                        <span>Tên vận động viên</span>
                        <h5>{{ matchData?.tour_player_team_1?.player_1?.display_name }}</h5>
                      </li>
                    </ul>
                    <ul v-if="matchData?.tour_player_team_1?.player_2" class="w-100">
                      <li class="w-100">
                        <span>Tên vận động viên</span>
                        <h5>{{ matchData?.tour_player_team_1?.player_2?.display_name }}</h5>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="w-50">
                  <div class="profile-card-title">
                    <h4>Đội 2</h4>
                  </div>
                  <div class="profile-contact-details mb-0 w-100">
                    <ul v-if="matchData?.tour_player_team_2?.player_1" class="w-100">
                      <li class="w-100">
                        <span>Tên vận động viên</span>
                        <h5>{{ matchData?.tour_player_team_2?.player_1?.display_name }}</h5>
                      </li>
                    </ul>
                    <ul v-if="matchData?.tour_player_team_2?.player_2" class="w-100">
                      <li class="w-100">
                        <span>Tên vận động viên</span>
                        <h5>{{ matchData?.tour_player_team_2?.player_2?.display_name }}</h5>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="profile-card mb-0">
                <div class="profile-card-title">
                  <h4>Nội dung thi đấu: {{ matchData?.category?.name }}</h4>
                </div>
                <div class="profile-contact-details mb-0">
                  <h6 class="mb-2">Vòng đấu: {{ matchData?.round?.name }}</h6>
                  <h6 class="mb-2">Ngày thi đấu: {{ convertDate(matchData?.start_date) }}</h6>
                  <h6 class="mb-2">Trạng thái: <span :class="statusMatchMap[matchData?.tour_match_status]?.class"> {{
                      statusMatchMap[matchData?.tour_match_status]?.text
                    }}</span></h6>
                  <h6>Nhà thi đấu: {{ matchData?.court?.arena?.name }} - Địa chỉ: {{ matchData?.court?.arena?.address }}
                    - Liên hệ: {{ matchData?.court?.arena?.contact_phone }}</h6>
                  <h6>Sân thi đấu: {{ matchData?.court?.name }}</h6>
                </div>
              </div>

              <div class="profile-card mb-0 w-100">
                <div class="profile-card-title">
                  <h4>Trọng tài</h4>
                </div>
                <div class="profile-contact-details mb-0 w-100">
                  <ul v-if="matchData?.umpire" class="w-100">
                    <li class="w-100">
                      <span>Tên trọng tài</span>
                      <h5>{{ matchData?.umpire.name }}</h5>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div id="match_history" class="tab-pane fade" role="tabpanel">
              <div class="review-box review-box-user d-flex">
                <div class="review-info">
                  <h5>Chi tiết trận</h5>
                  <div class="w-100">
                    <table class="table w-50">
                      <thead>
                      <tr>
                        <th scope="col">Vận động viên</th>
                        <th scope="col">Set 1</th>
                        <th scope="col">Set 2</th>
                        <th scope="col">Set 3</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <th scope="row">
                          {{ matchData?.tour_player_team_1?.player_1?.display_name }}
                          <br>
                          {{ matchData?.tour_player_team_1?.player_2?.display_name }}
                        </th>
                        <td>{{ set1[0] }}</td>
                        <td>{{ set2[0] }}</td>
                        <td>{{ set3[0] }}</td>
                      </tr>
                      <tr>
                        <th scope="row">
                          {{ matchData?.tour_player_team_2?.player_1?.display_name }}
                          <br>
                          {{ matchData?.tour_player_team_2?.player_2?.display_name }}
                        </th>
                        <td>{{ set1[1] }}</td>
                        <td>{{ set2[1] }}</td>
                        <td>{{ set3[1] }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="review-box review-box-user d-flex">
                <div class="review-info">
                  <h5>Kết quả: <span class="ms-2 h4">{{
                      matchData?.score ? JSON.parse(matchData.score).join(" - ") : ""
                    }}</span></h5>
                </div>
              </div>

              <div class="review-box review-box-user d-flex">
                <div class="review-info">
                  <h5>Đội thắng:
                    <span class="ms-2 h4">
                      {{
                        matchData?.winner?.player_1?.display_name
                      }}
                      <br>
                      {{
                       matchData?.winner?.player_2?.display_name
                      }}
                    </span>
                  </h5>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<style scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
